module.exports = __webpack_public_path__ + "img/yl3019.8fb7d1e0.png";